import _ from 'lodash';

export default {
  methods: {
    prototypeArray() {
      /** FUNKCJA NIE WYKORZYSTYWANA - ZWRACA NAJWIĘKSZĄ WARTOŚĆ W TABLICY */
      Array.prototype.max = function() {
        return Math.max.apply(null, this);
      };
      /**
       * Funkcja przesuwająca element w tablicy o określony offset
       * Funkcja wykorzystana w komponencie SORTING
       *
       * @param {type} element - element do przesunięcia
       * @param {type} offset - o ile ma być przesunięty
       * @returns {undefined}
       */
      Array.prototype.move = function(element, offset) {
        let index = this.indexOf(element);
        let newIndex = index + offset;

        if (newIndex > -1 && newIndex < this.length) {
          let removedElement = this.splice(index, 1)[0];
          this.splice(newIndex, 0, removedElement);
        }
      };

      Array.prototype.remove = function(what) {
        let a = arguments,
          L = a.length,
          ax;
        while (L && this.length) {
          what = a[--L];
          while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
          }
        }
        return this;
      };
    },
  },
  computed: {},
  watch: {},
};
